import { Chip } from './primitives/Chip';
import { Section } from './primitives/Section';
import { MonoKicker } from './primitives/MonoKicker';

const roles = [
    {
        title: 'Clinical operations',
        body: 'Sits in on your day and maps how the practice actually runs — what gets documented, what gets chased, and where the hours disappear to. Then decides with you what’s worth building first.',
    },
    {
        title: 'Documentation',
        body: 'Builds your note formats out of your own notes — your headings, your abbreviations, the bits you always include. Then tunes them as you edit, for as long as you’re with us.',
    },
    {
        title: 'Integrations',
        body: 'Connects Mohair to the systems you already run — your EMR included — and builds the pieces that don’t exist yet. This is the part other scribes leave to you.',
    },
];

export function FeatureCards() {
    return (
        <Section id="team" className="border-b border-border">
            <div className="flex flex-col gap-12">
                <div className="flex max-w-3xl flex-col gap-4">
                    <MonoKicker data-reveal>Your AI clinical team</MonoKicker>
                    <h2
                        data-reveal
                        className="font-display text-[clamp(30px,4vw,40px)] leading-[1.15] text-balance"
                    >
                        The people you&rsquo;d hire, if you could find them.
                    </h2>
                    <p
                        data-reveal
                        className="text-[clamp(16px,1.4vw,18px)] leading-[1.55] text-muted-foreground"
                    >
                        Most practices already know which jobs are worth
                        automating. What they don&rsquo;t have is a
                        clinical-operations engineer, a documentation specialist
                        and an integrations developer sitting in the back
                        office. Bringing on Mohair is how you get them without
                        opening four roles.
                    </p>
                </div>

                <div className="grid grid-cols-[repeat(auto-fit,minmax(min(280px,100%),1fr))] gap-6">
                    {roles.map((role) => (
                        <div
                            key={role.title}
                            data-reveal
                            className="flex flex-col gap-4 rounded-[16px] border border-border bg-card p-8"
                        >
                            <h3 className="font-display text-[26px] leading-[1.2] text-primary">
                                {role.title}
                            </h3>
                            <p className="text-[16px] leading-[1.55] text-muted-foreground">
                                {role.body}
                            </p>
                        </div>
                    ))}
                </div>

                <div
                    data-reveal
                    className="flex flex-wrap items-center gap-6 rounded-[16px] border border-border bg-card p-8"
                >
                    <Chip shape="pill" tone="sageSolid">
                        To be clear
                    </Chip>
                    <p className="min-w-[min(280px,100%)] flex-1 text-[16px] leading-[1.55] text-muted-foreground">
                        Our team builds and runs the systems. Every clinical
                        decision stays yours — we don&rsquo;t practise, triage,
                        or put ourselves between you and your client.
                    </p>
                </div>
            </div>
        </Section>
    );
}
